// extracted by mini-css-extract-plugin
export default {"recos":"i2-z","productCardOverride":"j2-z","rowHasBadge":"k2-z"};